import {isObject, isArray, isFunction} from 'OK/modules/shims/typeDetection';

export * from 'OK/modules/shims/typeDetection';

export const isArr = isArray;
export const isFunc = isFunction;

export function isRefObject<T = unknown>(value: unknown): value is { current: T } {
    return isObject(value) && 'current' in value;
}
